// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__iVhYC","textContainer":"Home_textContainer__AIanl","highlight":"Home_highlight__JhexC"};